import React, { Component, createRef } from "react";
import { Button, Col, Form, List, Modal, Row, Spin, Typography, Upload } from 'antd';
import { UploadOutlined, FilePdfFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import moment from 'moment';
import 'moment/locale/es';

const axios = require('axios').default;
moment.locale('es');
const { Title } = Typography;

class ModalProv extends Component {
    constructor(props) {
        super(props)
        this.state = {
        spinning: false,
        }
    }

    modalProveedores = createRef()

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    }

    render() {
        return (
            <Spin spinning={this.state.spinning}>
                <Form
                    layout="vertical"
                    ref={this.modalProveedores}
                    className="frm-proveedores"
                    name="formulario-proveedores-csv"
                >
                    <Row align="center" style={{ margin: "20px 0px", padding: '10px 0px' }}>
                        <List
                            style={{ justifyContent: "center" }}
                            align="center"
                            size="small"
                            header={<div>Toma en cuenta las siguientes consideraciones.</div>}
                            footer={<div>Descarga la plantilla CSV para subir múltiples proveedores.</div>}
                            dataSource={[
                                <div style={{ justifyContent: 'center', width: '100%' }}>- Encabezados requeridos: <b>alias, razon_social, rfc, linea_credito, plazo, saldo_positivo</b></div>,
                                <div style={{ justifyContent: 'center', width: '100%' }}>- Sin símbolos de moneda; usa punto decimal (ej. <code>1234.56</code>)</div>,
                                <div style={{ justifyContent: 'center', width: '100%' }}>- RFC en formato válido, se rechazarán duplicados por unicidad</div>,
                                <div style={{ justifyContent: 'center', width: '100%' }}>- Asegurarse que el dato esté escrito correctamente igual que en el sistema (incluyendo mayúsculas y acentos)</div>,
                            ]}
                            renderItem={item => <List.Item>{item}</List.Item>}
                        />
                    </Row>

                    <Row align="center" style={{ margin: "20px 0px", padding: '10px 0px' }}>
                        <Button
                            type="link"
                            onClick={async () => {
                                const { data } = await axios.get('/files/template-proveedores.csv', {
                                    responseType: 'blob',
                                })
                                const url = URL.createObjectURL(data)
                                const a = document.createElement('a')
                                a.href = url
                                a.download = 'template-proveedores.csv'
                                document.body.appendChild(a)
                                a.click()
                                a.remove()
                                URL.revokeObjectURL(url)
                            }}
                        >
                            <FilePdfFilled style={{ color: "red", fontSize: 24 }} />
                            Descargar Archivo
                        </Button>
                    </Row>

                    <Row align="center" style={{ margin: "20px 0px", padding: '10px 0px' }}>
                        <label>Una vez que hayas guardado tu archivo CSV con las transacciones, súbelo aqui.</label>
                    </Row>

                    <Row style={{ textAlign: "center", margin: "20px 0px", padding: '50px 0px' }}>
                        <Col span={24}>
                            <Form.Item label="" name="docs">
                                <Upload
                                    name="file"
                                    accept=".csv,.xlsx"
                                    headers={{ Authorization: axios.defaults.headers.common['Authorization'] }}
                                    className="avatar-uploader"
                                    action={axios.defaults.baseURL + "/proveedores/csv"}
                                    showUploadList={false}
                                    onChange={(info) => {
                                        const { status } = info.file

                                        if (status === 'uploading') {
                                            this.setState({ spinning: true })
                                        }

                                        if (status === 'done') {
                                            this.setState({ spinning: false })
                                            Modal.info({
                                                title: "Hemos subido el archivo. Revisa los resultados obtenidos en la descarga de resultados."
                                            })
                                            try {
                                                const url = window.URL.createObjectURL(new Blob([info.file.response]))
                                                const link = document.createElement('a')
                                                link.href = url
                                                link.setAttribute('download', 'resultado-proveedores.csv')
                                                document.body.appendChild(link)
                                                link.click()
                                                document.body.removeChild(link)
                                            } catch {
                                                
                                            }
                                            this.props.hideModal?.()
                                        }
                                        if (status === 'error') {
                                            this.setState({ spinning: false })
                                            Modal.error({
                                                title: "Error al subir el archivo",
                                                content: info.file.response ? info.file.response.message : 'El servidor no está disponible en este momento. Intenta más tarde.',
                                            })
                                        }
                                    }}
                                >
                                    <Button>
                                        <UploadOutlined /> Cargar
                                    </Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        )
    }
}

export default function (props) {
  const { visible, hideModal } = props;

  return (
    <Modal
      visible={visible}
      onCancel={hideModal}
      title={"Subir Múltiples Proveedores"}
      footer={null}
      destroyOnClose={true}
      zIndex={1000}
    >
      <ModalProv {...props} />
    </Modal>
  )
}
